import * as React from 'react';

import SocietySelector from '../Selectors/SocietySelector';
import { SocietyEnumValue } from '../../types/reminderPublisherTypes';

interface SocietySelectionStepProps {
    selectedSociety: SocietyEnumValue | null;
    isProcessing: boolean;
    onSocietyChange: (value: SocietyEnumValue | null) => void;
    onNext: () => void;
    onCancel: () => void;
}

export const SocietySelectionStep: React.FunctionComponent<SocietySelectionStepProps> = function ({
    selectedSociety,
    isProcessing,
    onSocietyChange,
    onNext,
    onCancel,
}) {
    const handleSocietyChange = React.useCallback(
        (society: SocietyEnumValue | null, checked: boolean) => {
            if (checked) {
                onSocietyChange(society);
            }
        },
        [onSocietyChange],
    );

    return (
        <SocietySelector
            selectedSociety={selectedSociety}
            isProcessing={isProcessing}
            onSelectionChange={handleSocietyChange}
            onCancel={onCancel}
            onContinue={onNext}
        />
    );
};
